/**
 * Grouped access to the local database for the journal feature:
 * PowerSync + drizzle + userId in a single hook.
 */
import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { useSession } from "@/lib/auth";
import { OFFLINE_CACHE_STALE_TIME_MS } from "@/lib/constants";

export function useJournalData() {
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();
  const session = useSession();
  const { userId } = session;

  return {
    db,
    drizzle,
    userId,
    staleTime: OFFLINE_CACHE_STALE_TIME_MS,
  };
}
